import { EnumEstadosBeneficios } from "../../constants/beneficio.constants";
import { BeneficioApi as Api } from "./beneficio.api";

export class BeneficioPendingFacade {
  static approve(item) {
    return Api.approve(item.id);
  }

  static countWithFilter({
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined
  }) {
    const filterDto = {
      busqueda,
      idComercio,
      subcategoria,
      estado: EnumEstadosBeneficios.PENDIENTE
    };

    return Api.countWithFilter(filterDto);
  }

  static getListWithFilter({
    desde = 1,
    hasta = 20,
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined
  }) {
    const filterDto = {
      busqueda,
      desde,
      hasta,
      idComercio,
      subcategoria,
      estado: EnumEstadosBeneficios.PENDIENTE
    };

    return Api.getListWithFilter(filterDto);
  }

  static getTipoDescuentoList() {
    return Api.getTipoDescuentoList();
  }

  //Agrego este método porque es el que está queriendo llamar y explota en la consola
  //pero no entiendo para qué se necesita
  //creo que es para el formulario de alta de beneficios, pero como el de pendientes lo reutiliza 
  // también lo  está queriendo llamar
  static getUnidadesDescuentoList() {    
    return Api.getUnidadesDescuentoList();
  }

  static reject(item) {
    return Api.reject(item.id);
  }
}
